import { render, staticRenderFns } from "./MarketingPos.vue?vue&type=template&id=48e8795a&scoped=true"
import script from "./MarketingPos.vue?vue&type=script&lang=js"
export * from "./MarketingPos.vue?vue&type=script&lang=js"
import style0 from "./MarketingPos.vue?vue&type=style&index=0&id=48e8795a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8795a",
  null
  
)

export default component.exports